<template>
  <v-btn color="warning" @click="transfer()">移譲</v-btn>
</template>

<script>
export default {
  props: {
    routes: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      switchAdminRoute: this.routes.switchAdminRoute,
    };
  },

  methods: {
    transfer() {
      if (
        window.confirm(
          "管理権限を移譲します。よろしいですか?\n権限を移譲すると以下の機能・情報が移行されます。\n\n・会員招待機能\n・決済情報",
        )
      ) {
        window.location.href = this.switchAdminRoute;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 750px) {
  .v-btn {
    min-width: 60px !important;
    margin: inherit;
  }
}
</style>
